// ============================================================
// PRODUCT PAGE — mobile gallery that peeks the next photo
// Builds a scroll-snap carousel from the thumbnail strip (phones only,
// via CSS), moves the Back / breadcrumb row underneath it, and gives the
// first photo a single small nudge so shoppers know to swipe left.
// Zoom (tap a photo) and colour-variant image swaps keep using the
// existing #gallery-main-img / switchGalleryImg code in product-page.liquid.
// ============================================================
(function () {
  var sticky = document.querySelector('.gallery__sticky');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('#gallery-thumbs .gallery__thumb[data-src]'));
  if (!sticky || thumbs.length < 2) return;

  var mq = window.matchMedia('(max-width: 768px)');

  // ---- Build the carousel -------------------------------------
  function sized(src, w) { return src.replace(/_1500x(\.\w+)/, '_' + w + 'x$1'); }

  var peek = document.createElement('div');
  peek.className = 'gallery__peek';
  var track = document.createElement('div');
  track.className = 'gallery__peek-track';
  var slides = thumbs.map(function (thumb, i) {
    var src = thumb.dataset.src;
    var slide = document.createElement('div');
    slide.className = 'gallery__peek-slide';
    var img = document.createElement('img');
    img.className = 'gallery__peek-img';
    img.src = sized(src, 750);
    img.srcset = sized(src, 750) + ' 750w, ' + sized(src, 1100) + ' 1100w, ' + src + ' 1500w';
    img.sizes = '84vw';
    img.alt = (thumb.querySelector('img') || {}).alt || '';
    img.loading = i < 2 ? 'eager' : 'lazy';
    img.decoding = 'async';
    slide.appendChild(img);
    track.appendChild(slide);
    return slide;
  });
  var counter = document.createElement('div');
  counter.className = 'gallery__peek-counter';
  counter.textContent = '1 / ' + slides.length;
  peek.appendChild(track);
  peek.appendChild(counter);
  sticky.appendChild(peek);
  sticky.classList.add('gallery__sticky--peek');

  // ---- Back / breadcrumb row sits below the photos on phones ---
  var nav = document.querySelector('.pp-nav-row');
  var gallery = sticky.parentNode;
  var navHome = nav ? { parent: nav.parentNode, next: nav.nextSibling } : null;
  function placeNav() {
    if (!nav) return;
    if (mq.matches) gallery.appendChild(nav);
    else navHome.parent.insertBefore(nav, navHome.next);
  }
  placeNav();
  if (mq.addEventListener) mq.addEventListener('change', placeNav);
  else if (mq.addListener) mq.addListener(placeNav);

  // ---- Position helpers ---------------------------------------
  var current = 0;
  function currentIndex() {
    var stride = slides[0].offsetWidth + 6;
    if (!stride) return 0;
    if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return slides.length - 1;
    return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / stride)));
  }
  function goTo(i, smooth) {
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  }

  var ticking = false;
  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      current = currentIndex();
      counter.textContent = (current + 1) + ' / ' + slides.length;
    });
  }, { passive: true });

  // ---- Tap a photo → the existing zoom lightbox ----------------
  track.addEventListener('click', function (e) {
    var slide = e.target.closest('.gallery__peek-slide');
    if (!slide) return;
    var i = slides.indexOf(slide);
    var mainImg = document.getElementById('gallery-main-img');
    if (i < 0 || !mainImg || !window.switchGalleryImg) return;
    window.switchGalleryImg(thumbs[i]);
    mainImg.click();
  });

  // Closing the lightbox after paging through it: land on the photo last viewed.
  var zoomOverlay = document.getElementById('zoom-overlay');
  var zoomCounter = document.getElementById('zoom-counter');
  if (zoomOverlay && zoomCounter && window.MutationObserver) {
    new MutationObserver(function () {
      if (zoomOverlay.classList.contains('open')) return;
      var n = parseInt(zoomCounter.textContent, 10);
      if (n >= 1 && n <= slides.length && n - 1 !== current) goTo(n - 1, false);
    }).observe(zoomOverlay, { attributes: true, attributeFilter: ['class'] });
  }

  // A colour/variant change swaps #gallery-main-img — follow it.
  var mainImg = document.getElementById('gallery-main-img');
  function fileOf(u) { return (u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(\.\w+)$/, '$1'); }
  if (mainImg && window.MutationObserver) {
    new MutationObserver(function () {
      var f = fileOf(mainImg.getAttribute('src'));
      for (var i = 0; i < thumbs.length; i++) {
        if (fileOf(thumbs[i].dataset.src) === f) {
          if (i !== current) goTo(i, true);
          return;
        }
      }
    }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
  }

  // ---- One-time nudge -----------------------------------------
  // Same idea as the first product card on the collection page: one small
  // slide and back, shortly after load, cancelled by any real interaction.
  // A brief instructional cue, so it also runs under reduced-motion.
  var nudgeCancelled = false;
  function cancelNudge() { nudgeCancelled = true; }
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
    track.addEventListener(ev, cancelNudge, { passive: true, once: true });
  });

  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function finish() { track.style.scrollSnapType = ''; }
  function animate(from, to, ms, done) {
    var start = null;
    function frame(ts) {
      if (nudgeCancelled) return finish();
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / ms);
      track.scrollLeft = from + (to - from) * ease(t);
      if (t < 1) requestAnimationFrame(frame); else done();
    }
    requestAnimationFrame(frame);
  }

  setTimeout(function () {
    if (!mq.matches || nudgeCancelled || track.scrollLeft > 2 || !track.offsetWidth) return;
    var dist = Math.round(track.clientWidth * 0.12);
    track.style.scrollSnapType = 'none'; // otherwise snapping fights the animation
    animate(0, dist, 480, function () {
      setTimeout(function () {
        if (nudgeCancelled) return finish();
        animate(dist, 0, 700, finish);
      }, 250);
    });
  }, 900);
})();
